import ReportsMenu from "./ReportsMenu";
import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import { toast, ToastContainer } from "react-toastify";
import { NavLink, Link } from "react-router-dom";
import moment from "moment";
import Pagination from "../General/Pagination";
import { Form } from "react-bootstrap";
import MonthsDropDown from "../Shared/MonthsDropDown";
import YearsDropDown from "../Shared/YearsDropDown";
import csvDownload from "json-to-csv-export";
import Modal from "react-bootstrap/Modal";

const fmtAmount = (n) =>
  Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });

const ConcessionReport = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [showFilters, setShowFilters] = useState(true);
  const [loading, setLoading] = useState(false);
  const [listOfLedger, setLedger] = useState([]);
  const [validated, setValidated] = useState(false);
  const [loaddata, setLoaddata] = useState(false);

  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totals, setTotals] = useState({
    gross: 0,
    concession: 0,
    net: 0,
  });

  const [Wing, setWing] = useState("0");
  const [Section, setSection] = useState("0");
  const [Session, setSession] = useState("0");
  const [Class, setClass] = useState("0");
  const [ReportMonth, setReportMonth] = useState(moment().format("M"));
  const [ReportYear, setReportYear] = useState(moment().format("YYYY"));

  const [appliedFilters, setAppliedFilters] = useState({
    ReportYear: moment().format("YYYY"),
    ReportMonth: moment().format("M"),
    Wing: "0",
    Class: "0",
    Section: "0",
    Session: "0",
  });

  const [showDetailModal, setShowDetailModal] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [detailStudents, setDetailStudents] = useState([]);
  const [selectedRule, setSelectedRule] = useState(null);
  const [detailTotals, setDetailTotals] = useState({
    gross: 0,
    concession: 0,
    net: 0,
  });

  useEffect(() => {
    document.title = "Concession Report";
  }, []);

  useEffect(() => {
    setLoading(true);
    const data = {
      AccessKey,
      UserID,
      MemberType,
      pageNo,
      pageSize,
      ReportYear: appliedFilters.ReportYear,
      ReportMonth: appliedFilters.ReportMonth,
      Wing_Id: Number(appliedFilters.Wing) || 0,
      Class_Id: Number(appliedFilters.Class) || 0,
      Section_Id: Number(appliedFilters.Section) || 0,
      SessionID: Number(appliedFilters.Session) || 0,
    };

    axios({
      method: "post",
      url: config.base_url + "/Reports/GetConcessionReport",
      headers: { "Content-Type": "application/json" },
      data,
    })
      .then(function (response) {
        const list = response.data?.ListofRecords;
        setLedger(Array.isArray(list) ? list : []);
        setTotalRecords(
          typeof response.data?.totalRecords === "number"
            ? response.data.totalRecords
            : Array.isArray(list)
            ? list.length
            : 0
        );
        setTotals({
          gross: response.data?.TotalGrossFee ?? 0,
          concession:
            response.data?.TotalConcession ?? response.data?.TotalAmount ?? 0,
          net: response.data?.TotalNetFee ?? 0,
        });
        setLoading(false);
      })
      .catch(function () {
        setLedger([]);
        setTotalRecords(0);
        setTotals({ gross: 0, concession: 0, net: 0 });
        setLoading(false);
      });
  }, [pageNo, pageSize, appliedFilters, AccessKey, UserID, MemberType]);

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    } else {
      if (!form.ReportMonth.value || !form.ReportYear.value) {
        toast.error("Please select month and year.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        return;
      }
      setAppliedFilters({
        ReportYear: form.ReportYear.value,
        ReportMonth: form.ReportMonth.value,
        Wing: form.Wing.value || "0",
        Class: form.Class.value || "0",
        Section: form.Section.value || "0",
        Session: form.Session?.value || "0",
      });
      setPageNo(1);
    }
    setValidated(true);
  };

  const handlePageChange = (page) => {
    setPageNo(page);
  };

  const buildDetailPrintUrl = (item) => {
    const params = new URLSearchParams({
      ReportYear: appliedFilters.ReportYear,
      ReportMonth: appliedFilters.ReportMonth,
      ConcessionRuleID: String(item.ConcessionRuleID || ""),
      ConcessionCode: item.ConcessionCode || "",
      RuleName: item.Concession_Rule_Name || "",
      Wing_Id: appliedFilters.Wing,
      Class_Id: appliedFilters.Class,
      Section_Id: appliedFilters.Section,
      SessionID: appliedFilters.Session,
    });
    return `/Reports/ConcessionReportDetail?${params.toString()}`;
  };

  const openConcessionDetail = (item) => {
    setSelectedRule(item);
    setShowDetailModal(true);
    setDetailLoading(true);
    setDetailStudents([]);

    axios({
      method: "post",
      url: config.base_url + "/Reports/GetConcessionReportDetail",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        ReportYear: appliedFilters.ReportYear,
        ReportMonth: appliedFilters.ReportMonth,
        Concession_Rule_ID: item.ConcessionRuleID,
        FeeCode: item.ConcessionCode || "",
        Title: item.Concession_Rule_Name || "",
        Wing_Id: Number(appliedFilters.Wing) || 0,
        Class_Id: Number(appliedFilters.Class) || 0,
        Section_Id: Number(appliedFilters.Section) || 0,
        SessionID: Number(appliedFilters.Session) || 0,
        pageSize: 10000,
      },
    })
      .then(function (response) {
        if (response.data.status_code === 1) {
          setDetailStudents(response.data.ListofRecords || []);
          setDetailTotals({
            gross: response.data.TotalGrossFee ?? 0,
            concession: response.data.TotalConcession ?? 0,
            net: response.data.TotalNetFee ?? 0,
          });
        } else {
          setDetailStudents([]);
          setDetailTotals({ gross: 0, concession: 0, net: 0 });
          toast.error(response.data.status_message || "Unable to load detail.", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setDetailLoading(false);
      })
      .catch(function () {
        setDetailStudents([]);
        setDetailTotals({ gross: 0, concession: 0, net: 0 });
        setDetailLoading(false);
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const closeDetailModal = () => {
    setShowDetailModal(false);
    setSelectedRule(null);
    setDetailStudents([]);
  };

  const fetchAllForExport = () =>
    axios({
      method: "post",
      url: config.base_url + "/Reports/GetConcessionReport",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        ReportYear: appliedFilters.ReportYear,
        ReportMonth: appliedFilters.ReportMonth,
        Wing_Id: Number(appliedFilters.Wing) || 0,
        Class_Id: Number(appliedFilters.Class) || 0,
        Section_Id: Number(appliedFilters.Section) || 0,
        SessionID: Number(appliedFilters.Session) || 0,
      },
    });

  const handleSubmitForCvs = () => {
    setLoaddata(true);
    fetchAllForExport()
      .then(function (response) {
        if (response.data.status_code === 1) {
          if (response.data.totalRecords > 0) {
            const data = response.data.ListofRecords || [];
            const listOfLedgerNew = data.map((rest) => ({
              Serial_No: rest.Serial_No,
              Concession_Rule: rest.Concession_Rule_Name,
              Code: rest.ConcessionCode,
              Percentage: rest.Concession_Percentage,
              Students: rest.No_Of_Students,
              Gross_Fee: rest.GrossFee,
              Concession: rest.ConcessionAmount,
              Net_Fee: rest.NetFee,
            }));
            csvDownload({
              data: listOfLedgerNew,
              filename: "ConcessionReport",
              delimiter: ",",
              headers: [
                "Serial_No",
                "Concession_Rule",
                "Code",
                "Percentage",
                "Students",
                "Gross_Fee",
                "Concession",
                "Net_Fee",
              ],
            });
          } else {
            toast.error("There is no data available for download", {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        } else {
          toast.error(response.data.status_message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
        setLoaddata(false);
      })
      .catch(function () {
        toast.error("Network Error..", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoaddata(false);
      });
  };

  const renderLedger = () => {
    if (listOfLedger != null && listOfLedger.length > 0) {
      return listOfLedger.map((item, index) => (
        <tr key={`${item.ConcessionRuleID}-${item.ConcessionCode}-${index}`}>
          <td>{item.Serial_No}</td>
          <td>
            <button
              type="button"
              className="btn btn-link p-0 text-start"
              onClick={() => openConcessionDetail(item)}
            >
              {item.Concession_Rule_Name}
            </button>
          </td>
          <td>{item.ConcessionCode}</td>
          <td className="text-end">{item.Concession_Percentage}%</td>
          <td className="text-end">{item.No_Of_Students}</td>
          <td className="text-end">{fmtAmount(item.GrossFee)}</td>
          <td className="text-end">{fmtAmount(item.ConcessionAmount)}</td>
          <td className="text-end">{fmtAmount(item.NetFee)}</td>
        </tr>
      ));
    }
    return (
      <tr>
        <td colSpan="8">
          <h4
            className="mt-3"
            style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}
          >
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ReportsMenu />
      <ToastContainer />
      <div className="page-head">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/Dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/Reports/ReportsDashboard">Reports</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Concession Report
                  </li>
                </ol>
              </nav>
              <div className="page-title">Concession Report</div>
            </div>
            <div className="col-md-6">
              <div className="page-right-actions">
                <button
                  type="button"
                  onClick={() => setShowFilters((prev) => !prev)}
                  className="button button-white button-icon"
                >
                  {showFilters ? "Hide Filters" : "Show Filters"}
                  <i className="ri-filter-3-line"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className={`collapse ${showFilters ? "show" : ""}`}>
        <div className="page-content">
          <div className="container">
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
              <div className="card mb-2">
                <div className="card-body p-md-4">
                  <div className="row align-items-end gy-3">
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Session</label>
                        <select
                          className="form-select"
                          name="Session"
                          value={Session}
                          onChange={(e) => {
                            setSession(e.target.value);
                            setClass("0");
                            setWing("0");
                            setSection("0");
                          }}
                        >
                          <option value="0">--- All ---</option>
                          <SessionsDropDown selectedSession={Session} />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Wing</label>
                        <select
                          name="Wing"
                          className="form-select"
                          value={Wing}
                          onChange={(e) => {
                            setWing(e.target.value);
                            setClass("0");
                            setSection("0");
                          }}
                        >
                          <option value="0">--- All ---</option>
                          <WingsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Class</label>
                        <select
                          className="form-select"
                          name="Class"
                          value={Class}
                          onChange={(e) => {
                            setClass(e.target.value);
                            setSection("0");
                          }}
                        >
                          <option value="0">--- All ---</option>
                          {Session !== "0" && Wing !== "0" && (
                            <ClassesDropDown
                              SessionID={Session}
                              WingID={Wing}
                            />
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Section</label>
                        <select
                          className="form-select"
                          name="Section"
                          value={Section}
                          onChange={(e) => setSection(e.target.value)}
                        >
                          <option value="0">--- All ---</option>
                          {Class !== "0" && (
                            <SectionDropDown ClassID={Class} />
                          )}
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Month</label>
                        <select
                          name="ReportMonth"
                          value={ReportMonth}
                          onChange={(e) => setReportMonth(e.target.value)}
                          className="form-select"
                          required
                        >
                          <option value="">Please Select</option>
                          <MonthsDropDown />
                        </select>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="form-group mb-0">
                        <label>Select Year</label>
                        <select
                          name="ReportYear"
                          value={ReportYear}
                          onChange={(e) => setReportYear(e.target.value)}
                          className="form-select"
                          required
                        >
                          <option value="">Please Select</option>
                          <YearsDropDown currentYearSelectd={ReportYear} />
                        </select>
                      </div>
                    </div>
                    {loaddata ? (
                      <div className="col-md-2 offset-md-2 text-center">
                        <Spinner animation="border" size="sm" />
                      </div>
                    ) : (
                      <div className="col-md-2 offset-md-2 text-end">
                        <button
                          type="button"
                          onClick={handleSubmitForCvs}
                          className="print-icon btn btn-link p-0 mt-3"
                          title="Export Excel"
                        >
                          <i className="ri-file-excel-2-line fs-4"></i>
                        </button>
                      </div>
                    )}
                    <div className="col-md-2">
                      <button
                        type="submit"
                        className="w-100 button button-primary"
                      >
                        Search
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </div>
      <div className="page-content">
        <div className="container">
          <div className="card">
            <div className="card-body">
              <table className="table table-theme">
                <thead>
                  <tr>
                    <th colSpan="5">Total Records: {totalRecords}</th>
                    <th className="text-end">{fmtAmount(totals.gross)}</th>
                    <th className="text-end">{fmtAmount(totals.concession)}</th>
                    <th className="text-end">{fmtAmount(totals.net)}</th>
                  </tr>
                  <tr>
                    <th>Sr#</th>
                    <th>Concession Rule (click for detail)</th>
                    <th>Code</th>
                    <th className="text-end">%</th>
                    <th className="text-end">Students</th>
                    <th className="text-end">Gross Fee</th>
                    <th className="text-end">Concession</th>
                    <th className="text-end">Net Fee</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr>
                      <td className="text-center" colSpan="8">
                        <Spinner animation="border" />
                      </td>
                    </tr>
                  ) : (
                    renderLedger()
                  )}
                </tbody>
              </table>
              {totalRecords > 10 && (
                <div className="pagination-wrap">
                  <div className="row align-items-center">
                    <div className="col-md-2">
                      <select
                        className="form-select"
                        style={{ width: "100px" }}
                        value={pageSize}
                        onChange={(e) => {
                          setPageNo(1);
                          setPageSize(parseInt(e.target.value, 10));
                        }}
                      >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                      </select>
                    </div>
                    <Pagination
                      pageNo={pageNo}
                      pageSize={pageSize}
                      totalRecords={totalRecords}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="container">
          <div className="card mt-2">
            <div className="card-body p-md-4 text-end">
              <NavLink
                className="button button-primary"
                to={`/Reports/ConcessionPrint?ReportYear=${appliedFilters.ReportYear}&ReportMonth=${appliedFilters.ReportMonth}&Wing_Id=${appliedFilters.Wing}&Class_Id=${appliedFilters.Class}&Section_Id=${appliedFilters.Section}&SessionID=${appliedFilters.Session}`}
                target="_blank"
                rel="noreferrer"
              >
                Print Report
              </NavLink>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={showDetailModal}
        onHide={closeDetailModal}
        size="xl"
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {selectedRule?.Concession_Rule_Name || "Concession Detail"}
            {selectedRule?.ConcessionCode ? ` (${selectedRule.ConcessionCode})` : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedRule && (
            <p className="text-muted small mb-2">
              Summary row — Gross: {fmtAmount(selectedRule.GrossFee)}, Concession:{" "}
              {fmtAmount(selectedRule.ConcessionAmount)}, Net: {fmtAmount(selectedRule.NetFee)}
            </p>
          )}
          <table className="table table-theme table-sm">
            <thead>
              <tr>
                <th>Sr#</th>
                <th>Registration No</th>
                <th>Student Name</th>
                <th>Class</th>
                <th>Section</th>
                <th className="text-end">Gross Fee</th>
                <th className="text-end">Concession</th>
                <th className="text-end">Net Fee</th>
              </tr>
            </thead>
            <tbody>
              {detailLoading ? (
                <tr>
                  <td colSpan={8} className="text-center">
                    <Spinner animation="border" size="sm" />
                  </td>
                </tr>
              ) : detailStudents.length > 0 ? (
                <>
                  {detailStudents.map((row, idx) => (
                    <tr key={`${row.Student_ID}-${idx}`}>
                      <td>{row.Serial_No}</td>
                      <td>{row.Registration_No}</td>
                      <td>{row.Student_Name}</td>
                      <td>{row.Class_Name}</td>
                      <td>{row.Section_Name}</td>
                      <td className="text-end">{fmtAmount(row.GrossFee)}</td>
                      <td className="text-end">{fmtAmount(row.ConcessionAmount)}</td>
                      <td className="text-end">{fmtAmount(row.NetFee)}</td>
                    </tr>
                  ))}
                  <tr className="fw-semibold">
                    <td colSpan={5} className="text-end">
                      Total ({detailStudents.length} students)
                    </td>
                    <td className="text-end">{fmtAmount(detailTotals.gross)}</td>
                    <td className="text-end">{fmtAmount(detailTotals.concession)}</td>
                    <td className="text-end">{fmtAmount(detailTotals.net)}</td>
                  </tr>
                </>
              ) : (
                <tr>
                  <td colSpan={8}>No students found for this concession rule.</td>
                </tr>
              )}
            </tbody>
          </table>
        </Modal.Body>
        <Modal.Footer>
          {selectedRule && (
            <NavLink
              className="button button-white me-2"
              to={buildDetailPrintUrl(selectedRule)}
              target="_blank"
              rel="noreferrer"
            >
              Print Detail
            </NavLink>
          )}
          <button type="button" className="button button-primary" onClick={closeDetailModal}>
            Close
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ConcessionReport;
